import { Backdrop } from "@mui/material";
import React from "react";
import PawPrint from "../display/PawPrint";
import { ThemeContext } from "../../contexts/ThemeContext";

export default function Loader({ condition = true }) {
  const { mode } = React.useContext(ThemeContext);
  if (condition) {
    return (
      <Backdrop
        sx={{ backgroundColor: mode == "dark" ? "#191919" : "#ffffff", zIndex: 99 }}
        open={condition}
      >
        <PawPrint />
      </Backdrop>
    );
  }
}
